import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgxPaginationModule } from 'ngx-pagination';
import { MaterialModule } from 'src/app/core/material/material.module';
import { TableMovementsComponent } from './table-movements.component';
import { OperationDetailComponent } from './components/operation-detail/operation-detail.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MovementsFilterComponent } from './components/movements-filter/movements-filter.component';
import { CierreLotePopupComponent } from './components/cierre-lote-popup/cierre-lote-popup.component';
import { DescargarLiquidacionPopupComponent } from './components/descargar-liquidacion-popup/descargar-liquidacion-popup.component';
import { AuthGuard } from 'src/app/core/guards/auth.guard';
import { Permissions } from 'src/app/core/enums/permissions.enum';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { provideNgxMask } from 'ngx-mask';

export const MY_DATE_FORMATS = {
  parse: { dateInput: 'DD/MM/YYYY' },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

@NgModule({
  declarations: [
    TableMovementsComponent,
    OperationDetailComponent,
    MovementsFilterComponent,
    CierreLotePopupComponent,
    DescargarLiquidacionPopupComponent
  ],
  exports: [TableMovementsComponent, OperationDetailComponent],
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: TableMovementsComponent
      },
      {
        path: 'detail',
        component: OperationDetailComponent,
        canActivate: [AuthGuard],
        data: {
          paramkey: 'operationId',
          entity: 'operationId',
          permission: Permissions.MOVIMIENTO
        }
      }
    ]),
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatExpansionModule,
    NgxPaginationModule,
    MaterialModule,
    ReactiveFormsModule,
    MatToolbarModule,
    TranslateModule.forChild({
      isolate: false
    }),
    NgxMatSelectSearchModule,
    SharedModule,
    MatDatepickerModule,
    MatMomentDateModule
  ],
  providers: [
    DatePipe,
    provideNgxMask(),
    { provide: MAT_DATE_LOCALE, useValue: 'es' }, // <-- agrega esto
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }
  ]
})
export class TableMovementsModule {}
